/** How much of a loan has been paid back, as a bar. */
export default function RepaidBar({ original, outstanding }: { original: number; outstanding: number }) {
  const repaid = Math.max(0, original - outstanding);
  const pct = original > 0 ? Math.min(100, (repaid / original) * 100) : 0;
  return (
    <div className="budget-bar">
      <div className="budget-bar-track">
        <div className="budget-bar-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
